export default __webpack_public_path__ + "static/media/logo_masimo.ae9e4987.svg";